module.exports = __webpack_public_path__ + "img/zs-5.df246a95.png";